import { Inject, Injectable } from "@angular/core";
import { EnvironmentBase, ServiceBase, WebCommunicationService } from "@definitiv-packages/angular-dba-library";
import { ModuleMandantView, ModuleService } from "@definitiv-packages/angular-module-library";

@Injectable({
    providedIn: 'root'
})
export class ProjektModuleService extends ServiceBase {
    
    public Verwaltung : boolean             = false;
       
    constructor(
        webCommunicationService: WebCommunicationService,
        private moduleService:ModuleService,
        @Inject(EnvironmentBase) private environment: EnvironmentBase
    ) {
        super(webCommunicationService);
    }

    public init(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
      
            this.moduleService.getModuleMandantList().then(result=>{

                this.Verwaltung = this.getModule(result,1);
                
                
                resolve();
            })
        });
    }

    private getModule(module:ModuleMandantView[],moduleID:number):boolean
    {
        var x=module.find(x=>x.ModulID==moduleID)?.Aktiv;
        if(x==null)
            return false;
        return x>0?true : false;
    }
}
